const state = {
    status: "Online",
    downloadPercentage: 0
};

const getters = {
    status: state => state.status,
    downloadPercentage: state => state.downloadPercentage
};

const mutations = {
    setStatus: (state, data) => state.status = data,
    setDownloadPercentage: (state, data) => state.downloadPercentage = data
};

export default {
    namespaced: true,
    state,
    getters,
    mutations
};